import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetNfseNatureState = async (context) => {
  context.commit(types.RESET_NFSE_NATURE);
};

export const setSummaryNfseNatures = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('consumers.find-summary-nfse-nature-of-operation', body);

  context.commit(types.SET_PAGINATION_NFSE_NATURES, data.pagination);
  context.commit(types.SET_SUMMARY_NFSE_NATURES, data.data);
};

export const saveNfseNature = async (_, payload) => {
  const { id } = payload;

  if (!id) {
    await api().post('consumers.register-nfse-nature-of-operation', payload);
    return;
  }

  await api().post('consumers.update-nfse-nature-of-operation', payload);
};

export const setDetailedNfseNature = async (context, id) => {
  const { data } = await api().post('consumers.find-nfse-nature-of-operation', { id });

  context.commit(types.SET_DETAILED_NFSE_NATURE, data);
};
